import { initials, metaOf } from "../data/engine";
import type { useKagami } from "../state/useKagami";
import { Chip, CoverArt, mutedColor } from "./primitives";

type K = ReturnType<typeof useKagami>;

const SHELVES = ["All", "Watching", "Reading", "Completed", "Planned", "Dropped"];

export function Library({ k }: { k: K }) {
  return (
    <div>
      <h3 style={{ margin: 0 }}>Library</h3>

      <div style={{ display: "flex", alignItems: "center", gap: 5, flexWrap: "wrap", margin: "12px 0 16px" }}>
        {SHELVES.map((s) => (
          <Chip key={s} on={k.shelf === s} onClick={() => k.setShelf(s)}>{s}</Chip>
        ))}
      </div>

      <div className="k-grid">
        {k.shelfWorks.map((item) => (
          <article key={item.id} className="k-card card" style={{
            padding: 0, overflow: "hidden", background: "var(--color-surface)",
            boxShadow: "var(--shadow-sm)", gap: 0,
          }}>
            <CoverArt initials={initials(item.title)} coverPath={item.coverPath} accent
              onClick={() => k.setSelId(item.id)} style={{ aspectRatio: "3 / 4" }}
              badge={
                <span style={{
                  display: "inline-block", fontSize: 10, padding: "3px 7px", borderRadius: 6,
                  background: "var(--color-accent-800)", color: "var(--color-accent-100)",
                }}>{k.library[item.id]}</span>
              } />
            <div style={{ padding: "var(--k-pad)", display: "flex", flexDirection: "column", gap: 4 }}>
              <div style={{
                fontFamily: "var(--font-heading)", fontWeight: 500,
                fontSize: "var(--k-cardfont)", lineHeight: 1.25,
              }}>{item.title}</div>
              <div style={{ fontSize: 11, color: mutedColor(48) }}>{metaOf(item)}</div>
            </div>
          </article>
        ))}
      </div>

      {k.shelfWorks.length === 0 && (
        <div style={{ padding: "56px 0", textAlign: "center", color: mutedColor(50), fontSize: 13 }}>
          {k.libraryWorks.length ? "Nothing on this shelf." : "Nothing saved yet."}
        </div>
      )}
    </div>
  );
}
